import React from "react";
import * as R from "ramda";
import { Select } from "antd";

/**
 * video, image, audio, text
 * video: 视频
 * image: 图片
 * audio: 音频
 * text: 字幕
 */
export const ResourceTypeMap = {
  video: "视频",
  image: "图片",
  audio: "音频",
  text: "字幕",
};

const ResourceOptions = R.pipe(
  R.toPairs,
  R.map(([value, label]) => ({ value, label }))
)(ResourceTypeMap);

const { Option } = Select;

export const ResourceTypeSelect = (props) => {
  return (
    <Select {...props}>
      {ResourceOptions.map(({ value, label }) => (
        <Option key={value} value={value}>
          {label}
        </Option>
      ))}
    </Select>
  );
};


// WEBPACK FOOTER //
// ./src/containers/Video/widgets/form-item/resource-type-select.js